import { gql } from '@apollo/client';

// export const GET_BUY_MOTOR_POLICY_VAR_DETAILS = gql`
//   query getBuyMotorPolicyDetails {
//     buyMotorPolicy @client
//   }
// `;

// export const GET_BUY_MOTOR_POLICY_VAR_DETAILS_SCPA = gql`
//   query getBuyMotorPolicyDetails {
//     buyMotorPolicy @client
//   }
// `;

export const GET_BUY_HEALTH_POLICY_VAR_DETAILS = gql`
  query getBuyHealthPolicyDetails {
    buyHealthPolicy @client
  }
`;

export const SAVE_QUOTE_TWO_WHEELER = gql`
  mutation saveQuoteTW($input: TWQuoteInput) {
    saveQuoteTW(input: $input) {
      quoteNumber
      quoteCreationDate
      status
    }
  }
`;
export const SAVE_QUOTE = gql`
  mutation saveQuote($input: QuoteInput) {
    saveQuote(input: $input) {
      quoteNumber
      quoteCreationDate
      status
    }
  }
`;
export const RTO_LIST_BRAND_LIST_YEAR_RANGE = gql`
  query rtoBrandYearInfo(
    $filterRTOList: RtoLocInput
    $filterMakeList: MakeList
    $type: String
  ) {
    rtoList(filter: $filterRTOList) {
      rtoLocCode
      rtoLocDesc
      rtoAuthCode
    }
    makeList(filter: $filterMakeList) {
      code
      value
    }
    yearRange(type: $type) {
      minYr
      maxYr
    }
  }
`;

export const MODEL_DETAILS = gql`
  query modelDetails($filter: ModelList) {
    modelList(filter: $filter) {
      code
      value
    }
  }
`;

export const SEND_POLICY_SMS = gql`
  mutation sendPolicySms(
    $input: ProposalInput
    $proposalNumber: String
    $mobile: String
    $policyNumber: String
    $alternateMobileNos: [String]
  ) {
    sendPolicySMS(
      input: $input
      proposalNumber: $proposalNumber
      mobile: $mobile
      policyNumber: $policyNumber
      alternateMobileNos: $alternateMobileNos
    ) {
      message
    }
  }
`;

export const SEND_POLICY_EMAIL = gql`
  mutation sendPolicyEmail(
    $input: ProposalInput
    $proposalNumber: String
    $email: String
    $policyNumber: String
    $ccEmailIds: [String]
  ) {
    sendPolicyEmail(
      input: $input
      proposalNumber: $proposalNumber
      email: $email
      policyNumber: $policyNumber
      ccEmailIds: $ccEmailIds
    ) {
      message
    }
  }
`;

export const SEND_POLICY_PDF = gql`
  mutation sendPolicyPDF(
    $input: ProposalInput
    $proposalNumber: String
    $policyNumber: String
  ) {
    sendPolicyPDF(
      input: $input
      proposalNumber: $proposalNumber
      policyNumber: $policyNumber
    ) {
      base64Pdf
    }
  }
`;

export const GET_CUSTOMER_TYPE_DOMAIN = gql`
  query getCustomerTypeDomain {
    customerTypeList {
      code
      value
    }
  }
`;

export const SEND_PROPOSAL_PDF = gql`
  mutation sendProposalPDF(
    $input: ProposalInput
    $proposalNumber: String
  ) {
    sendProposalPDF(input: $input, proposalNumber: $proposalNumber) {
      base64Pdf
    }
  }
`;

export const BUY_POLICY = gql`
  mutation buyPolicy($input: PolicyInput) {
    issuePolicy(input: $input) {
      policyNo
      receiptID
      referenceNumber
      digiLink
      displayMessage
      additionalMessage
    }
  }
`;

export const QUERY_STATE = gql`
  query healthQuotePlans {
    healthQuote @client
    healthPlans @client
    selectedIntermediary @client
  }
`;

export const VEHICLE_DETAILS = gql`
  query getVehicleDetails($input: RegInput) {
    getVehicleDetails(input: $input) {
      make {
        code
        value
      }
      model {
        code
        value
      }
      variant {
        code
        value
      }
      fuelType
      seatingCapacity
      cubicCapacity
      carryingCapacity
      rto {
        rtoAuthCode
        rtoLocCode
        rtoLocDesc
      }
      manufactureYear
      regPurchaseDate
      engineNumber
      chasisNumber
      financerName
      prevInsurance {
        insurerName
        policyNumber
        expiryDate
        startDate
        coverType
        policyTenure
      }
    }
  }
`;

export const CUSTOMER_INDIVIDUAL_DROPDOWN_DETAIL = gql`
  query customerIndividualDetail {
    salutationList {
      code
      value
      gender
    }
    genderList {
      code
      value
    }
    maritalStatusList {
      code
      value
    }
    occupationList {
      code
      value
    }
    nomineeRelationshipList {
      code
      value
    }
    idProofTypeList {
      code
      value
    }
    nationalityList {
      code
      value
    }
  }
`;

export const GET_DATE_TIME = gql`
  query getDateTime {
    datetimeValue {
      time
      date
    }
  }
`;

export const PROPOSAL_PAYMENT_TYPE_LIST = gql`
  query proposalPaymentType {
    ProposalPaymentTypeList {
      code
      value
    }
  }
`;

export const CUSTOMER_ORGANISATIONAL_DROPDOWN_DETAIL = gql`
  query customerOrganisationDetails {
    organisationList {
      code
      value
    }
  }
`;

export const NOMINEE_DROPDOWN_DETAILS = gql`
  query nomineeDropDownDetails($productCode: String) {
    PRD_NomiRelationWithMemb(productCode: $productCode) {
      code
      value
    }
    PRD_ApointRelationWithMinNomi(productCode: $productCode) {
      code
      value
    }
  }
`;

export const PROPOSER_DROPDOWN_DETAIL = gql`
  query getProposerDropdownList($productCode: StrictNumber) {
    PRD_OccupationList(productCode: $productCode) {
      code
      value
    }
    PRD_PreExistDiseaseWaitPeriod(productCode: $productCode) {
      code
      value
    }
    PRD_NomiRelationWithMemb(productCode: $productCode) {
      code
      value
    }
    PRD_ApointRelationWithMinNomi(productCode: $productCode) {
      code
      value
    }
    PRD_CumulativeBonus(productCode: $productCode) {
      code
      value
    }
  }
`;

export const FINANCER_DROPDOWN_DETAILS = gql`
  query financerDetails($productCode: StrictNumber) {
    PRD_FinancerAgreementType(productCode: $productCode) {
      code
      value
    }
    PRD_IsYourVehicle(productCode: $productCode) {
      code
      value
    }
  }
`;

export const PREVIOUS_INSURER_COMPANY_LIST = gql`
  query prevCompanyList {
    rolloverCompanyList {
      code
      value
    }
  }
`;

export const LOB_PRODUCT_LIST = gql`
  query lobProductList {
    lobProductList {
      lob_name
      lob_code
      products {
        product_name
        product_code
        linkTo
      }
    }
  }
`;

export const CALCULATE_PREMIUM_FOR_PROPOSAL_TW = gql`
  query calculatePremiumProposalTW($input: TWProposalInput) {
    calculatePremiumForProposalTW(input: $input) {
      idv1
      idv2
      idv3
      tenure
      netODPremium
      netTPPremium
      loadingDiscount
      netPremium
      gst
      stampDuty
      totalPremium
      loading {
        name
        amount
      }
      discount {
        name
        amount
      }
      vehicleAge
      claimFreeYear
      creditScore
      warningMsg
    }
  }
`;
export const CALCULATE_PREMIUM_FOR_PROPOSAL = gql`
  query calculatePremiumForProposal($input: ProposalInputSCPA) {
    calculatePremiumForProposalSCPA(input: $input) {
      basePremium
      loadingDiscount
      netPremium
      gst
      stampDuty
      totalPremium
      loading {
        name
        amount
      }
      discount {
        name
        amount
      }
      breakup {
        relationship
        gender
        age
        premium
        ppcTestLevel
      }
      warningMsg
    }
  }
`;

export const SAVE_PROPOSAL_TW = gql`
  mutation saveProposalTW($input: TWProposalInput) {
    saveProposalTW(input: $input) {
      proposalNumber
      proposalEndDate
      proposalStatus
      isApplicableForPayment
      premium {
        idv1
        idv2
        idv3
        tenure
        netODPremium
        netTPPremium
        loadingDiscount
        netPremium
        gst
        stampDuty
        totalPremium
        loading {
          name
          amount
        }
        discount {
          name
          amount
        }
        vehicleAge
        claimFreeYear
        creditScore
      }
      customerID
      warningMsg
    }
  }
`;
export const SAVE_PROPOSAL = gql`
  mutation saveProposalSCPA($input: ProposalInputSCPA) {
    saveProposalSCPA(input: $input) {
      customerID
      proposalNumber
      proposalEndDate
      proposalStatus
      isApplicableForPayment
      premium {
        basePremium
        loadingDiscount
        netPremium
        gst
        stampDuty
        totalPremium
        loading {
          name
          amount
        }
        discount {
          name
          amount
        }
        breakup {
          relationship
          gender
          age
          premium
        }
      }
      warningMsg
    }
  }
`;
export const CHECK_IMD_CONFIG = gql`
  query checkConfigImd($intermediaryCode: String){
    checkConfigImd( intermediaryCode: $intermediaryCode){
      isConfiguredIMD
    }
  }
`;
export const PROFILE_DETAILS = gql`
  query userMyDetail {
    userMyDetail {
      userId
      userType {
        typeName
      }
      profile {
        userImage
        firstName
        middleName
        lastName
        mobileNumber
        emailId
      }
      userCategory {
        categoryName
      }
      organisation {
        intermediaries {
          intermediaryName
          intermediaryCode
          isSelected
        }
      }
      status
    }
  }
`;